import { useMemo, useState } from "react";
import PropTypes from "prop-types";

import { strCode } from "../../../../../consts";
import { t } from "../../../../../services";

import { SVG } from "../../../../../components";
import { FormSection } from "../../../../../templates";
import { ChangeHistorySectionStyled, OpenModalButton } from "./styled";

import { ChangeHistoryList } from "./ChangeHistoryList/ChangeHistoryList";
import { HistoryLogsModal } from "./HistoryLogsModal/HistoryLogsModal";

export const ChangeHistory = ({ changeHistory = [], loading, isAdminUser }) => {
  const [modalActive, setModalActive] = useState(false);

  const history = useMemo(() => {
    return changeHistory?.filter((record) => record?.type);
  }, [changeHistory]);

  return (
    <>
      <ChangeHistorySectionStyled>
        <FormSection title={t(strCode.HISTORY_TITLE)}>
          <ChangeHistoryList history={history} loading={loading} isAdminUser={isAdminUser} />
        </FormSection>

        {!!history?.length && !loading && (
          <OpenModalButton
            onClick={() => setModalActive(true)}
            hasHoverCircle
            tooltipLabel={t(strCode.VIEV_IN_DIALOG_TOOLTIP)}
            xShift={-50}>
            <SVG.OpenElementIcon />
          </OpenModalButton>
        )}
      </ChangeHistorySectionStyled>

      {!!history?.length && !loading && (
        <HistoryLogsModal history={history} active={modalActive} setActive={setModalActive} />
      )}
    </>
  );
};

ChangeHistory.propTypes = {
  changeHistory: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool,
  isAdminUser: PropTypes.bool
};
